import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, createElementBlock as _createElementBlock } from "vue"

import {computed, getCurrentInstance, ref} from 'vue';
import Htmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import ReviewValue from "~/chat/vue/widget/tabs/reviews/ReviewValue.vue";
import ChatForm from "~/chat/vue/widget/form/ChatForm.vue";
import ChatFormItem from "~/chat/vue/widget/form/ChatFormItem.vue";
import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";
import Dictionary from "~/ts/library/Dictionary";
import {WidgetStore} from "~/chat/ts/store/Widget";
import {OperatorsStore} from "~/chat/ts/store/Operators";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {ConfigStore} from "~/chat/ts/store/Config";
import {TAB_TYPE_REVIEWS} from "~/chat/ts/data/ITab";
import AnalyticCounters from "~/chat/ts/service/AnalyticCounters";
import {__} from "~/ts/library/Translate";
import ApiCallback, {API_CALLBACK_SEND_RATE} from "~/chat/ts/service/api/methods/ApiCallback";
import ChatTextareaInput from "~/chat/vue/widget/form/fields/ChatTextareaInput.vue";
import {CLIENT_DATA_TYPE_TEXTAREA} from "~/chat/ts/data/IClient";
import {ITextareaField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import IChatUploadFile from "~/chat/vue/widget/form/IChatUploadFile";
import ChatAttachList from "~/chat/vue/widget/tabs/chat/ChatAttachList.vue";
import SendTextMessageToClient from "~/chat/ts/service/autoActions/actions/SendTextMessageToClient";


interface IModel {
    fields: Dictionary<any>
    rate: string,
    comment: string,
    attachments: IChatUploadFile[]
}

const __default__ = {
    name: "ReviewFormContent"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let model = ref<IModel>({
    fields: {},
    rate: WidgetStore.sendReviewDefaultRate.value,
    comment: null,
    attachments: []
});
let isLoading = ref(false);

let commentField = computed<ITextareaField>(() => {
    return {
        type: CLIENT_DATA_TYPE_TEXTAREA,
        descr: null,
        name: "REVIEW_COMMENT",
        placeholder: rateConfig.value.placeholder,
        upload: rateConfig.value.upload,
        isPassword: false
    };
});

let htmlBefore = computed(() => {
    return tab.value ? SendTextMessageToClient.replaceTextVariables(tab.value.content.html, null, true) : null;
});

let htmlAfter = computed(() => {
    return tab.value ? SendTextMessageToClient.replaceTextVariables(tab.value.content.html_footer, null, true) : null;
});

let tab = computed(() => {
    return ConfigStore.tabs.value.find(tab => tab.type == TAB_TYPE_REVIEWS);
});

let rateConfig = computed(() => {
    return ConfigStore.siteParams.value.params.rate;
});

let instance = getCurrentInstance().proxy;


async function send() {
    let operator = OperatorsStore.selected.value.operator;
    isLoading.value = true;
    try {
        let result = await ChatApiRequest.make({
            method: "sendRate",
            p: {
                ...model.value,
                chatMode: OperatorsStore.isOffline.value ? "offline" : "online",
                //operatorId: operator ? operator.id : null,
                attachments: model.value.attachments.map(item => item.id)
            }
        });
        result.showMessage(instance, false);
        if (result.isSuccess()) {
            WidgetStore.closeSendReview();

            AnalyticCounters.send("Rate sent", __("EVENT_SEND_RATE"));

            ApiCallback.emit(API_CALLBACK_SEND_RATE, {
                comment: model.value.comment,
                rate: model.value.rate,
                //TODO: убрать
                //operator: operator ? operator.username : null,
                operatorId: operator?.id

            });

        }
    } catch (e) {

    }
    isLoading.value = false;
}

function onUpload(files: IChatUploadFile[]) {
    model.value.attachments.push(...files);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(htmlBefore))
      ? (_openBlock(), _createBlock(Htmlify, {
          key: 0,
          class: "mb-4",
          tag: "div",
          value: _unref(htmlBefore),
          escape: false
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    _createVNode(ReviewValue, {
      modelValue: _unref(model).rate,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).rate) = $event)),
      system: _unref(rateConfig).values,
      class: "value",
      "model-is-listening": ""
    }, null, 8, ["modelValue", "system"]),
    _createVNode(ChatForm, {
      class: "mt-4",
      form: _unref(rateConfig).collectContacts,
      modelValue: _unref(model).fields,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).fields) = $event))
    }, _createSlots({
      append: _withCtx(() => [
        _createVNode(ChatFormItem, null, {
          default: _withCtx(() => [
            _createVNode(ChatFormButton, {
              "show-load": _unref(isLoading),
              class: "w-100",
              type: "primary",
              round: "",
              onClick: send,
              disabled: !_unref(model).rate
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("SEND")), 1)
              ]),
              _: 1
            }, 8, ["show-load", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      (!_unref(rateConfig).hideCommentField || _unref(rateConfig).needComment)
        ? {
            name: "before-eula-or-append",
            fn: _withCtx(() => [
              _createVNode(ChatFormItem, null, {
                default: _withCtx(() => [
                  _createVNode(ChatTextareaInput, {
                    modelValue: _unref(model).comment,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).comment) = $event)),
                    required: !!_unref(rateConfig).needComment,
                    field: _unref(commentField),
                    "upload-is-listening": "",
                    onUpload: onUpload
                  }, null, 8, ["modelValue", "required", "field"]),
                  _createVNode(ChatAttachList, {
                    class: "mt-2",
                    attachments: _unref(model).attachments,
                    "onUpdate:attachments": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).attachments) = $event))
                  }, null, 8, ["attachments"])
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["form", "modelValue"]),
    (_unref(htmlAfter))
      ? (_openBlock(), _createBlock(Htmlify, {
          key: 1,
          value: _unref(htmlAfter),
          escape: false,
          tag: "div",
          class: "mt-4"
        }, null, 8, ["value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})